module.exports = __webpack_public_path__ + "img/compass-needle.00b699f0.svg";